var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLections(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.792,
    height: 63.792,
    viewBox: "0 0 63.792 63.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unlimited",
    transform: "translate(0.667 0.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Small_Unlimited",
    "data-name": "Icon/Small/Unlimited",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    transform: "translate(6.613 6.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M6.981,0H3.49A3.49,3.49,0,0,0,0,3.49V45.374a3.49,3.49,0,0,0,3.49,3.49H45.374a3.49,3.49,0,0,0,3.49-3.49v-3.49",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link-2",
    "data-name": "path-1-link",
    transform: "translate(6.981 6.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-2",
    "data-name": "path-1",
    d: "M6.981,0H3.49A3.49,3.49,0,0,0,0,3.49V45.374a3.49,3.49,0,0,0,3.49,3.49H45.374a3.49,3.49,0,0,0,3.49-3.49v-3.49",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link-3",
    "data-name": "path-1-link",
    transform: "translate(0 13.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1-3",
    "data-name": "path-1",
    d: "M6.981,0H3.49A3.49,3.49,0,0,0,0,3.49V45.374a3.49,3.49,0,0,0,3.49,3.49H45.374a3.49,3.49,0,0,0,3.49-3.49v-3.49",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.49.333H53.374a3.49,3.49,0,0,1,3.49,3.49V45.708a3.49,3.49,0,0,1-3.49,3.49H11.49A3.49,3.49,0,0,1,8,45.708V3.824A3.49,3.49,0,0,1,11.49.333Z",
    transform: "translate(5.594 -0.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M13.333,28.226l23.56-23.56",
    transform: "translate(16.024 4.875)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M31.961,17.628V3.667H18",
    transform: "translate(21.771 5.059)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLections);
export default __webpack_public_path__ + "static/media/Lections.7b66fb14.svg";
export { ForwardRef as ReactComponent };